import BackOffice from '@/pages/statistics/BackOffice.vue'

export default [
  {
    path: '/backoffice/',
    alias: [],
    component: BackOffice
  }
]
